import { Link } from 'react-router-dom';

interface LogoProps {
  height?: number;
}

/**
 * Только SVG логотипа. Для intro-анимации (см. .logo-svg в styles/main.css).
 * Обёртку выбирай caller'ом — обычно <HeaderLogo/> или <AuthLogo/> ниже.
 */
export function Logo({ height = 34 }: LogoProps) {
  return (
    <svg
      className="logo-svg"
      height={height}
      viewBox="0 0 118 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon points="0,0 17,0 10,16 17,16 5,34 3,34 10,18 3,18" fill="#CBFF47" />
      <text
        x="23"
        y="11"
        fontFamily="'Barlow Condensed',sans-serif"
        fontSize="6.5"
        fontWeight="700"
        fill="rgba(255,255,255,0.38)"
        letterSpacing="3.5"
      >
        EASY
      </text>
      <text
        x="23"
        y="30"
        fontFamily="'Barlow Condensed',sans-serif"
        fontSize="19"
        fontWeight="900"
        fill="#ffffff"
        letterSpacing="-0.5"
      >
        FITNESS
      </text>
    </svg>
  );
}

/** Логотип-ссылка для шапки (.logo > svg). */
export function HeaderLogo() {
  return (
    <Link to="/" className="logo">
      <Logo />
    </Link>
  );
}

/** Логотип для login/register (.login-logo > a > svg) — тёмный болт без glow, см. main.css. */
export function AuthLogo() {
  return (
    <div className="login-logo">
      <Link to="/">
        <Logo />
      </Link>
    </div>
  );
}
